import React, { Component } from 'react';
import Firestore from '@FireStore';
import {
  Typography,
  Grid,
  Button,
  Theme,
  Box,
  alpha,
  CheckCircle,
  createStyles,
  withStyles,
} from '@quillbot/design-system';
import MyInputBox from '@Common/components/myInputBox/MyInputBox';
import { validEmail } from 'core/utils';
import Link from 'next/link';
import { handleAuthTrack } from 'src/authentication/handlers/authentication';
import { withRouter, UseRouter } from 'next/router';

const styles = (theme: Theme) =>
  createStyles({
    header: {
      fontSize: '28px',
      textAlign: 'center',
      paddingTop: '25px',
    },

    authContainer: {},

    subHeader: {
      fontSize: '16px',
      marginBottom: 24,
      textAlign: 'center',
    },
    coreContainer: {
      padding: '24px 16px',
      width: '100%',
      margin: 'auto',
      maxWidth: '400px',
      [theme.breakpoints.down(400)]: {
        width: '100%',
      },
    },
    containerStyle: {
      transition: 'all .2s',
      margin: 'auto',
      //  transform: `scale(${scale})`,
      transformOrigin: 'top center',
      [theme.breakpoints.down('sm')]: {
        transition: '',
        transformOrigin: '',
      },
    },
    successWrapper: {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      borderRadius: '8px',
      display: 'flex',
      padding: '16px !important',
      marginBottom: 16,
    },
    successText: {
      fontSize: '16px',
      marginLeft: 16,
      textAlign: 'left',
    },
  });
// TODO: fix inheritance
// interface Props extends WithStyles {
interface Props {
  location: Location;
  history: History;
  router: UseRouter;
  classes: any;
}

interface State {
  errorMessage: string;
  success: boolean;
  containerStyle: object;
}

class Forget extends Component<Props, State> {
  location: Location;

  history: History;

  emailField: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);
    this.location = this.props.location;
    this.history = this.props.history;

    this.state = {
      errorMessage: '',
      success: false,
      containerStyle: {},
    };
    this.emailField = React.createRef<HTMLInputElement>();
  }

  componentDidMount() {
    handleAuthTrack(this.props.router);
  }

  handleForgetPassword = () => {
    // var email = document.getElementById("recoverEmail").value;
    const email = this.emailField.current?.value?.trim();
    if (email) {
      if (!validEmail(email)) {
        this.setState({ errorMessage: 'Please enter valid email' });
        return;
      }
      const firestore = Firestore.getInstance();
      firestore.recoverPassword(
        email,
        () => {
          this.setState({ success: true, errorMessage: '' });
        },
        (e: { code: string; message: string }) => {
          if (e) {
            this.setState({ errorMessage: e.message, success: false });
          }
        }
      );
    } else {
      this.setState({ errorMessage: 'Required' });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div className="auth-root">
        <div>
          <h1 className="pageTitle">Reset Password</h1>
        </div>
        <Box
          boxShadow={3}
          className=" auth-container"
          id="registerContainer"
          style={this.state.containerStyle}
        >
          {/* <div className="auth-container-top-border" /> */}
          <Grid container className={classes.coreContainer} spacing={1}>
            <Typography classes={{ body1: classes.subHeader }}>
              Enter your email, and we’ll send you instructions on how to reset
              your password.
            </Typography>
            {this.state.success ? (
              <Grid item xs={12} className={classes.successWrapper}>
                <CheckCircle color="primary" />
                <Typography
                  classes={{ body1: classes.successText }}
                  color="primary"
                >
                  Reset instructions have been sent to your email! Please check
                  your email to continue.
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} style={{ padding: '0px 0' }}>
                  <MyInputBox
                    fullWidth
                    required
                    id="recoverEmail"
                    size="small"
                    label="Email"
                    defaultValue=""
                    inputRef={this.emailField}
                    variant="filled"
                    error={!!this.state.errorMessage}
                    helperText={this.state.errorMessage}
                    onKeyUp={(event) => {
                      this.setState({ errorMessage: '' });
                      if (event.keyCode === 13) {
                        event.preventDefault();
                        this.handleForgetPassword();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} style={{ padding: '16px 0' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="auth-btn"
                    fullWidth
                    onClick={this.handleForgetPassword}
                  >
                    Send me reset instructions
                  </Button>
                </Grid>
              </>
            )}
            <Grid item xs={12} className="qbp-textCenter">
              <Link
                href={{
                  pathname: '/login',
                  query: {
                    ...this.props.router.query,
                    referrer: 'forgotPasswordPage',
                  },
                }}
              >
                Back to Log In
              </Link>
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Forget));
